<style lang="less">
    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal{
            top: 0;
        }
    }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
</style>
<template>
<div>
    <template v-if="!singleMode">
    <Row  :gutter="10" type="flex" justify="start" align="middle">
        <Col v-if="onselfFlag">
            <CheckBox :config="userConfig" :size="myConfig.size" :fatherValue="isoneself"  @input="input"></CheckBox>
        </Col>
        <Col v-if="hackReset && statusFlag">
            <Tag  v-for="(temp,index) in statusTag" v-if="index < myConfig.statusConfig.showNum" style="cursor: pointer;" :checked="temp.checkflag" :name="temp.code" checkable color="primary" @on-change="statusChange">{{temp.name}}</Tag>
        </Col>
        <Col v-if="hackReset && statusFlag && statusdownflag">
            <Dropdown>
                <a href="javascript:void(0)" style="color: #515a6e">
                    更多
                    <Icon type="ios-arrow-down"></Icon>
                </a>
                 <DropdownMenu slot="list">
                     <DropdownItem v-for="(temp,index) in statusTag"  v-if="index >= myConfig.statusConfig.showNum">
                          <Tag  :name="temp.code"  :checked="temp.checkflag" checkable color="primary" @on-change="statusChange">{{temp.name}}</Tag>
                     </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </COl>
        <Col v-if="fuzzyQueryFlag">
            <Input search @on-search="search" v-model="searchValue" clearable :placeholder="searchPlaceholder" :size="myConfig.size" :style="myConfig.fuzzyQueryStyle"/>
        </Col>
        <Col v-if="filterBtnFlag">
            <Button size="small"  @click="filterSearch"  :size="myConfig.size"  icon="ios-funnel-outline"></Button>
        </Col>
   </Row>
   </template>
   <template v-else>
       <Input v-if="fuzzyQuery" search @on-search="search" clearable v-model="searchValue" :placeholder="searchPlaceholder" :size="myConfig.size" :style="myConfig.fuzzyQueryStyle"/>
       <Button v-if="filter && myConfig.filterConfig.showBtn"  size="small"  @click="filterSearch"  :size="myConfig.size"  icon="ios-funnel-outline"></Button>
   </template>
   <Modal :styles="{width:'60%'}"  title="查询条件"  v-model="filterFlag" :footer-hide="false">
           <BillConditionsBox ref='filter' :config="myConfig.filterConfig" style="min-height:250px" :dictData="dictData"></BillConditionsBox>
                <Row slot="footer" type="flex" justify="center" align="middle" :gutter="8">
                    <Col>
                    <Button  type="primary" style="width:80px"  @click="doFilterSearch">查询</Button>
                    </Col>
                    <Col>
                    <Button  style="width:80px"  @click="doClearFilter">重置</Button>
                    </Col>
                    <Col>
                    <Button  style="width:80px" @click="cancelFilter">关闭</Button>
                    </Col>
                </Row>
            
    </Modal>
</div>
</template>

<script>
export default {
    name:'quickquerytoolbar',
    data () {
        return {
            myConfig:{
                size:'default',
                onselfField:'',
                onselfText:'',
                statusConfig:{
                    name:'',
                    textField:'name',
                    valueField:'code',
                    showNum:2,
                    dictkey:''
                },
                fuzzyQueryCode:'',
                fuzzyQueryText:'',
                fuzzyQueryStyle:'width:300px',
                filterConfig:{
                    showBtn:true,
                    items:[]
                }
            },
            userConfig: {
                trueValue:'Y',
                falseValue:'N'
            },
            statusTag:[],
            onselfFlag:false,
            statusFlag:false,
            fuzzyQueryFlag:false,
            filterBtnFlag:false,
            isoneself:'N',
            statusdownflag:false,
            searchPlaceholder:'',
            searchValue:'',
            filterFlag:false,
            filterParam:{},
            hackReset:true
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        },
        singleMode : {
            type: Boolean,
            default:false
        },
        fuzzyQuery : {
            type: Boolean,
            default:true
        },
        filter : {
            type: Boolean,
            default:true
        }
    },
    created()   {
        this.myConfig = Object.assign({}, this.myConfig, this.config);
        if (this.myConfig.onselfField) {
            this.onselfFlag = true;
            if (this.myConfig.onselfText) {
                this.userConfig.showText = this.myConfig.onselfText;
            }
        }
        if (this.myConfig.statusConfig.name) {
            let data = [];
            if (this.myConfig.statusConfig.data && this.myConfig.statusConfig.data.length > 0) {
                data = this.myConfig.statusConfig.data;
            } else {
                let dictkey = this.myConfig.statusConfig.dictkey;
                if (this.myConfig.statusConfig.customDictkey) {
                    dictkey = this.myConfig.statusConfig.customDictkey
                }
                if (dictkey) {
                    data = this.dictData[dictkey];
                }
            }
            if (data && data.length > 0) {
                this.statusFlag = true;
                if (data.length > this.myConfig.statusConfig.showNum) {
                    this.statusdownflag = true;
                } else {
                    this.statusdownflag = false;
                }
                let textField = 'name';
                let valueField = 'code';
                if (this.myConfig.statusConfig.textField) {
                    textField = this.myConfig.statusConfig.textField;
                }
                if (this.myConfig.statusConfig.valueField) {
                    valueField = this.myConfig.statusConfig.valueField;
                }
                data.forEach(el => {
                    let obj = {};
                    obj.name = el[textField];
                    obj.code = el[valueField];
                    obj.checkflag= false;
                    this.statusTag.push(obj);
                });
            }
        }
        
        if (this.myConfig.fuzzyQueryCode) {
            this.fuzzyQueryFlag = true;
            if (this.myConfig.fuzzyQueryText) {
                this.searchPlaceholder = this.myConfig.fuzzyQueryText;
            }
        }
        if (this.myConfig.filterConfig && this.myConfig.filterConfig.items && this.myConfig.filterConfig.items.length > 0) {
            this.filterBtnFlag = true;
        }
    },
    methods: {
        statusChange (value, name) {
            let index = this.statusTag.findIndex(el => el.code === name);
            if (index > -1) {
                let tmp = Object.assign({},this.statusTag[index],{checkflag:value});
                this.statusTag.splice(index,1,tmp);
            }
            this.$emit('on-change');
        },
        input(obj) {
            this.isoneself = obj.value; 
            this.$emit('on-change');
        },
        search() {
            this.$emit('on-change');
        },
        filterSearch () {
            this.filterFlag = true;
        },
        doFilterSearch () {
            this.filterParam = this.$refs.filter.getQuerySearchParam();
            this.filterFlag = false;
            this.$emit('on-change');
        },
        cancelFilter () {
            this.filterFlag = false;
        },
        doClearFilter () {
            this.filterParam = {};
            this.$refs.filter.clearData();
        },
        clearData () {
            if (this.onselfFlag) {
                this.isoneself = 'N';
            }
            if (this.statusFlag) {
                this.hackReset = false;
                this.statusTag.forEach(el => {
                    el.checkflag = false;
                });
                this.$nextTick(() => {
                    this.hackReset = true;
                });
            }
            if (this.fuzzyQueryFlag) {
                this.searchValue = '';
            }
            if (this.filterBtnFlag) {
                this.filterParam = {};
                this.$refs.filter.clearData();
            }
        },
        getData() {
            let para = {};
            if (this.onselfFlag) {
                if (this.isoneself === 'Y') {
                    para[this.myConfig.onselfField] = this.getUserCode();
                }
            }
            if (this.statusFlag) {
                let str = '';
                this.statusTag.forEach(el => {
                    if (el.checkflag) {
                        str = str + el.code + ',';
                    }
                });
                if (str) {
                    para[this.myConfig.statusConfig.name] = {'$in':str.substring(0,str.length - 1)};
                }
            }
            if (this.fuzzyQueryFlag) {
                if (this.searchValue) {
                    let str = this.myConfig.fuzzyQueryCode.split(',');
                    if (str.length === 1) {
                        para[str[0]] = {'LIKE':'%' +this.searchValue + '%'};
                    } else if (str.length > 1) {
                        para['$or'] = [];
                        str.forEach(el => {
                            let temp = {};
                            temp[el] =  {'LIKE':'%' +this.searchValue + '%'};
                            para['$or'].push(temp);
                        });
                    } 
                }
            }
            if (this.filterBtnFlag) {
                para = Object.assign(para, this.filterParam);
            }
            return para;
        }
    }
};
</script>

<style>

</style>>


// WEBPACK FOOTER //
// src/components/layouttemplate/quickquerytoolbar.vue